import { UserPermissions } from '@received/pricing-model';
import { EnterpriseContract, EnterpriseContractV2, ResellerAgreement, ReferralAgreement } from '../../pages/Contracts';
import { NodeEnvTypes, RoutesType } from '../../types/generalTypes';
import { Subscriptions } from '../../pages/_ContractsViews/Subscriptions/Subscriptions';
import { Agreements } from '../../pages/_ContractsViews/Agreements/Agreements';
import { EnterprisesContracts } from '../../pages/_ContractsViews/EnterprisesContracts/EnterprisesContracts';
import { isEmbedded } from '../../services/embedded/embeddedService';

// Embedded (cross-origin iframe) flow renders the V2 contract page; regular in-app keeps the legacy
// page. Resolved per render from the embedded flag (?embeddedPage=true, persisted to sessionStorage).
const ContractRoute = () => (isEmbedded() ? <EnterpriseContractV2 /> : <EnterpriseContract />);

export const contracts: RoutesType[] = [
	{
		name: 'contracts',
		path: '',
		showOnSidebar: true,
		iconType: 'license_template',
		subElements: [
			{
				name: 'enterprises',
				dataTestId: 'enterprises-contracts',
				path: '/enterprises-contracts',
				showOnSidebar: true,
				element: <EnterprisesContracts />,
				licenses: [UserPermissions.BILLING],
			},
			{
				name: 'subscriptions',
				path: '/subscriptions-contracts',
				showOnSidebar: window._env_.NODE_ENV != NodeEnvTypes.PRODUCTION,
				element: <Subscriptions />,
				licenses: [UserPermissions.BILLING],
			},
			{
				name: 'partnerAgreements',
				path: '/agreements',
				showOnSidebar: true,
				element: <Agreements />,
				licenses: [UserPermissions.PARTNERS],
			},
		],
	},
	{
		name: 'contract',
		path: '/contract',
		showOnSidebar: false,
		element: <ContractRoute />,
	},
	{
		name: 'contractById',
		path: '/contract/:id',
		showOnSidebar: false,
		element: <ContractRoute />,
	},
	{
		name: 'referralAgreement',
		path: '/referral-agreement',
		showOnSidebar: false,
		element: <ReferralAgreement />,
	},
	{
		name: 'resellerAgreement',
		path: '/reseller-agreement',
		showOnSidebar: false,
		element: <ResellerAgreement />,
	},
];
